import React from "react";
import { connect } from "react-redux";
import IAppState from "../../../redux/types/IAppState";
import IShortCutKeys from "../../../redux/types/IShortCutKeys";

export interface IListenToShortCutKeysDataGridTableComponentProps {
    showSearchModal: () => void;
    addRow: () => void;
    deleteRow: () => void;
    handleClickOutside: (event: any) => void;
};
export interface IStateProps {shortCutKeys: IShortCutKeys[]}

export const DO_NOT_SHOW_MODAL = "DO_NOT_SHOW_MODAL";

type IListenToShortCutKeysDataGridTableConnectProps = IListenToShortCutKeysDataGridTableComponentProps & IStateProps;

const ListenToShortCutKeysDataGridTable: React.FC<IListenToShortCutKeysDataGridTableConnectProps> = ({
    shortCutKeys,
    showSearchModal,
    addRow,
    deleteRow,
    handleClickOutside,
}) => {
    const [keysPressed, setKeysPressed] = React.useState([]);
    const areCorrectKeysPressed = (actionCode, keysPressed) => {
        const shortCutKeysCommaSeparatedString = shortCutKeys && shortCutKeys.find(key => key.actionCode === actionCode)?.key
        const shortCutKeysArray = shortCutKeysCommaSeparatedString && shortCutKeysCommaSeparatedString.split(',');
        let filteredRequiredPressedKeys = shortCutKeysArray && shortCutKeysArray.filter(keyString => keysPressed[keyString]);
        return filteredRequiredPressedKeys?.length === shortCutKeysArray?.length;
    }

    const showSearchView  = (e, pressedKey) => {     
    if (areCorrectKeysPressed("SEARCH_CURRENT_GRID_ROW", pressedKey)){
        showSearchModal()
      }
    }

    const addTableRow  = (e, pressedKey) => {     
        if (areCorrectKeysPressed("ADD_NEW_IN_GRID", pressedKey)){
            addRow()
          }
        }
        const deleteTableRow = (e, pressedKey) => {     
            if (areCorrectKeysPressed("DELETE_GRID_ROW", pressedKey)){
                e.preventDefault();
                deleteRow()
              }
            }


    const setKeyState = (event, state) => {
        setKeysPressed((prevState) => {
            const newState = {...prevState};
            newState[event.key] = state;
            showSearchView(event, newState);
            addTableRow(event, newState);
            deleteTableRow(event, newState);
            return newState});
     }

     const setTheKeyPressFalse = (event) => {
        setKeysPressed((prevState) => {
            const newState = {...prevState};
            newState[event.key] = false;
            return newState});
     }
     const handleBlur = () => {
        setKeysPressed((prevState) => ([]))
    };

 
    React.useEffect(() => {
        const onKeyDown = (event) => {
            if (event.target && (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable)) return;
            setKeyState(event, true)
        }

        const onKeyUp = (event) => {
            if (event.target && (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable)) return;
            setTheKeyPressFalse(event)
        }

        document.addEventListener('click', handleClickOutside);
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);
        window.addEventListener('blur', handleBlur);

        return () => {
            document.removeEventListener('click', handleClickOutside);
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('keyup', onKeyUp);
            window.removeEventListener('blur', handleBlur);
        }
    }, [])

return <></>;

}

export default connect((state: IAppState, props: IListenToShortCutKeysDataGridTableComponentProps) => ({
    shortCutKeys: state.repertoire.shortCutKeys,
}), null)(ListenToShortCutKeysDataGridTable);
